import Axios from 'axios';
import * as React from 'react';
import { ApiClient } from './ApiClient';
import { IApiClient } from './IApiClient';

const client = new ApiClient(Axios.create()) as IApiClient;
export const ApiContext = React.createContext(client);
